/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

SmoothScroll();

function checkScreenWidth() {
    const viewport = document.querySelector('meta[name="viewport"]');
    viewport.setAttribute('content', 'width=' + (screen.width <= 340 ? '340' : 'device-width, height=device-height, initial-scale=1'));
}

window.addEventListener('DOMContentLoaded', checkScreenWidth);
window.addEventListener('resize', checkScreenWidth);

document.querySelectorAll('.anchor').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        let target = this.getAttribute('href');
        if (target) {
            gsap.to(window, {
                duration: 0,
                scrollTo: { y: target }
            });
        }
    });
});

let mask_phone = document.querySelector('form input[name=phone]');
window.intlTelInput(mask_phone, {
    autoPlaceholder: 'off',
    hiddenInput: mask_phone.name,
    initialCountry: 'md',
    preferredCountries: ['md', 'ro'],
    separateDialCode: true,
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
});

$('.btn-custom').on('click', function (e) {
    dataLayer.push({ 'event': 'begin_form' });
});

var form_start = false;
$('form .form-control').focus(function () {
    if (form_start == false) {
        dataLayer.push({ 'event': 'form_start' });
        form_start = true;
    }
});

$('form').submit(function (e) {
    e.preventDefault();

    const btn_submit = $(this).find('button[type="submit"]');
    btn_submit.attr('disabled', true);

    dataLayer.push({ 'event': 'form_submit' });

    const alert = (message, type) => {
        let wrapper = document.createElement('div')
        wrapper.innerHTML = [
            `<div class="alert alert-${type} alert-dismissible" role="alert">`,
            `   <div>${message}</div>`,
            '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
            '</div>'
        ].join('');

        $('.form-response').append(wrapper);
    }

    $.ajax({
        url: $(this).attr('action'),
        method: $(this).attr('method'),
        data: $(this).serialize() + '&submit=submit',
        dataType: 'json',
    }).done(function (response) {
        if (response == true) {
            alert('Mesajul a fost expediat cu succes!', 'success');
            dataLayer.push({ 'event': 'lead_generated' });
            window.location.href = "https://telegram.me/banidinbeauty_bot?start=216f726e-75de-4e04-b965-130f164069f6";
        } else {
            alert('Eroare în procesarea formularului. Vă rugăm să încercați din nou mai târziu.', 'warning');
        }
    }).fail(function (error) {
        alert('Eroare în timpul expedierii formularului. Vă rugăm să încercați din nou.', 'danger');
    }).always(function () {
        btn_submit.attr('disabled', false);
    });

    this.reset();
});